module.exports = __webpack_public_path__ + "static/media/Libuda-Logo.63d5c65b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Libuda-Logo.svg
// module id = 345
// module chunks = 0